import React from "react";
import {
  TheClientContent,
  TheClientSidebar,
  TheClientFooter,
  TheClientHeader,
} from "./index";

const TheClientLayout = () => {
  return (
    <div className="c-app c-default-layout">
      <TheClientSidebar />
      <div className="c-wrapper">
        <TheClientHeader />
        <div className="c-body">
          <TheClientContent />
        </div>
        <TheClientFooter />
      </div>
    </div>
  );
};

export default TheClientLayout;
